import { basename, dirname, join } from 'path';

export default function (path) {
  const thumbDirname = join(dirname(path), 'thumbnails');
  const imageName = basename(path).replace(/\.(png|jpg)$/, '.png');
  const thumbFullPath = join(thumbDirname, imageName);
  return thumbFullPath;
}



// WEBPACK FOOTER //
// ./application/js/lib/thumbnail-helper.js